"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackRouteChange = void 0;
const router_1 = require("next/router");
const react_1 = require("react");
const ym_1 = require("../lib/ym");
const useTrackRouteChange = ({ tagID }) => {
    (0, react_1.useEffect)(() => {
        const handleRouteChange = (url) => {
            (0, ym_1.ym)(tagID, 'hit', url.toString());
        };
        router_1.Router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router_1.Router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [tagID]);
};
exports.useTrackRouteChange = useTrackRouteChange;
//# sourceMappingURL=useTrackRouteChange.js.map